import { ErrorMessage } from 'formik'
import { ChangeEvent} from 'react'

export default function SelectBox(props: SelectBoxFieldProps ) {

    const changeDropDown = (event: ChangeEvent<HTMLSelectElement>) => {
        props.onChangeOperator(event.target.value)
    }
    return (
        <div className='form-group'>
            {props.label && <label htmlFor={props.field}>{props.label}  {props.required && <>(*)</>}</label> }
            {props.formikError && 
                <ErrorMessage name={props.field}>
                    { msg => <div className={`text-danger d-inline-block ms-1`}>{msg}</div> }
                </ErrorMessage>
            }
            <select name={props.field} className={`form-select form-control ${ props.extraClasses}`} disabled={props.disabled} aria-label={props.ariaLabel} value={props.selectedId.toString()} onChange={changeDropDown}>
                {props.firstOption &&
                    <option key={-1} value="-1">{props.firstOption}</option>
                }
                {props.options.map((option, index) => {
                    return(    
                        <option key={index} value={ option.id.toString() }>{ option.value.toString() }</option>
                    )
                })}
            </select>
        </div>
    )
}

interface SelectBoxFieldProps{
    field: string;
    displayName: string;
    options: {
        id: number | string,
        value: string
    }[];
    selectedId: number;
    ariaLabel?: string;
    extraClasses?: string;
    firstOption?: string;
    disabled: boolean;
    label?: string;
    onChangeOperator(selected: string): void;
    required: boolean;
    formikError: boolean;
}

SelectBox.defaultProps = {
    extraClasses: '',
    selectedId: -1,
    disabled: false,
    required: false,
    formikError: false
}